import { FC, SVGProps } from 'react'
import theme from 'theme'

const SelectDropdownIcon: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" {...props}>
    <path
      d="M14.625 6.1875L9 11.8125L3.375 6.1875"
      stroke={theme.colors.dustyRoseGray}
      strokeWidth="1.125"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)

export default SelectDropdownIcon
